document.addEventListener('DOMContentLoaded', () => {
  initGroupedPickers();
});

// Re-init after Shopify re-renders the section
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initGroupedPickers();
  });
}

function initGroupedPickers() {
  document.querySelectorAll('.grouped-picker').forEach((picker) => {
    if (picker.dataset.initialized) return;
    picker.dataset.initialized = 'true';

    picker.addEventListener('click', (event) => {
      const swatch = event.target.closest('.grouped-picker__swatch');
      if (!swatch) return;
      if (swatch.classList.contains('grouped-picker__swatch--unavailable')) return;

      const variantSelects = picker.closest('variant-selects');
      if (!variantSelects) return;

      const groupValue = swatch.dataset.groupValue;
      const colorValue = swatch.dataset.colorValue;

      // Update visual state
      picker.querySelectorAll('.grouped-picker__swatch--selected').forEach((el) => {
        el.classList.remove('grouped-picker__swatch--selected');
      });
      swatch.classList.add('grouped-picker__swatch--selected');

      // Update selected label text
      const selectedLabel = picker.querySelector('[data-grouped-picker-selected]');
      if (selectedLabel) {
        selectedLabel.textContent = groupValue + ' - ' + colorValue;
      }

      // Find and check the matching hidden radio inputs
      const hiddenInputs = variantSelects.querySelector('.grouped-picker__hidden-inputs');
      if (!hiddenInputs) return;

      const fieldsets = hiddenInputs.querySelectorAll('fieldset');

      // Check hårdhet radio
      if (fieldsets[0]) {
        const groupRadio = Array.from(fieldsets[0].querySelectorAll('input[type="radio"]')).find(
          (input) => input.value === groupValue
        );
        if (groupRadio) groupRadio.checked = true;
      }

      // Check färg radio and dispatch change to trigger VariantSelects
      if (fieldsets[1]) {
        const colorRadio = Array.from(fieldsets[1].querySelectorAll('input[type="radio"]')).find(
          (input) => input.value === colorValue
        );
        if (colorRadio) {
          colorRadio.checked = true;
          colorRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
}

// Re-init after section re-render (ProductInfo DOM swap)
new MutationObserver(() => {
  initGroupedPickers();
}).observe(document.body, { childList: true, subtree: true });
